<vdr-page-block>
  <vdr-action-bar>
    <vdr-ab-left></vdr-ab-left>
    <vdr-ab-right>
      <vdr-action-bar-items
        locationId="package-review-list"
      ></vdr-action-bar-items>
    </vdr-ab-right>
  </vdr-action-bar>
</vdr-page-block>
<vdr-split-view
  [rightPanelOpen]="!!(activeRowId$ | async)"
  (closeClicked)="closeContents()"
>
  <ng-template vdrSplitViewLeft>
    <custom-data-table
      class="mt-2"
      id="package-review-summary-table"
      [items]="items$ | async"
      [itemsPerPage]="itemsPerPage$ | async"
      [totalItems]="totalItems$ | async"
      [currentPage]="currentPage$ | async"
      [filters]="filters"
      [expandedRowIndex]="expandedRowIndex"
      (pageChange)="setPageNumber($event)"
      (itemsPerPageChange)="setItemsPerPage($event)"
    >
      <!-- <vdr-bulk-action-menu
        locationId="package-review-list"
        [hostComponent]="this"
        [selectionManager]="selectionManager"
      ></vdr-bulk-action-menu> -->
      <vdr-dt2-search
        [searchTermControl]="searchTermControl"
        [searchTermPlaceholder]="'Search by Product Name'"
      ></vdr-dt2-search>

      <expand-div>
        <ng-template let-item="item" let-index="index">
          <package-review-summary-expand-content
            [item]="item"
            [index]="index"
          />
        </ng-template>
      </expand-div>

      <vdr-dt2-column
        [heading]="'common.id' | translate"
        id="id"
        [hiddenByDefault]="false"
        [sort]="sorts.get('id')"
      >
        <ng-template let-packageReview="item">
          {{ packageReview.id }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'common.productName' | translate"
        id="created-at"
        [hiddenByDefault]="false"
      >
        <ng-template let-packageReview="item">
          <div style="display: flex">
            <a
              class="button-ghost"
              [routerLink]="['/catalog/products', packageReview.id]"
            >
              <span
                style="
                  max-width: 200px;
                  overflow-x: hidden;
                  text-overflow: ellipsis;
                "
                >{{ packageReview.name }}</span
              >
              <clr-icon shape="arrow right"></clr-icon>
            </a>

            <div
              *ngIf="packageReview.freeGifts"
              class="freegift-badge button-ghost"
            >
              Free gift <clr-icon shape="shopping-bag" />
            </div>
          </div>
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'common.totalOrders' | translate"
        id="total-quantity"
        [hiddenByDefault]="false"
      >
        <ng-template let-packageReview="item">
          <button 
            class="button-ghost" 
            (click)="showOrdersPopup(packageReview)"
            style="cursor: pointer; text-decoration: underline;"
          >
            {{ packageReview.totalOrder }}
          </button>
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'Total Packages'"
        id="total-weight"
        [hiddenByDefault]="false"
      >
        <ng-template let-packageReview="item">
          <button 
            class="button-ghost" 
            (click)="showPackageReviewsPopup(packageReview)"
            style="cursor: pointer; text-decoration: underline;"
          >
            {{ packageReview.totalPackage }}
          </button>
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'Detail'"
        id="view-contents"
        [hiddenByDefault]="false"
      >
        <ng-template let-inbounding="item" let-i="index">
          <button class="button-ghost" (click)="setRowExpand(i)">
            <span>{{ "common.view-contents" | translate }}</span>
            <clr-icon shape="file-group"></clr-icon>
          </button>
        </ng-template>
      </vdr-dt2-column>
    </custom-data-table>
  </ng-template>
  <ng-template vdrSplitViewRight splitViewTitle="  ">
    <h1>Hello</h1>
    <h1>Hello</h1>
  </ng-template>
</vdr-split-view>

<!-- Orders Popup Modal -->
<div *ngIf="showOrdersModal" class="modal-overlay" (click)="closeOrdersPopup()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Orders for {{ selectedProduct?.name }}</h3>
      <button class="close-btn" (click)="closeOrdersPopup()">×</button>
    </div>
    <div class="orders-popup-content">
      <div *ngIf="selectedProduct?.orders?.length > 0" class="orders-list">
        <a 
          *ngFor="let order of selectedProduct.orders" 
          [routerLink]="['/orders', order.id]"
          (click)="closeOrdersPopup()"
          class="order-link"
        >
          <vdr-chip class="order-chip">
            {{ order.code }}
            <clr-icon shape="arrow right"></clr-icon>
          </vdr-chip>
        </a>
      </div>
      <div *ngIf="!selectedProduct?.orders?.length" class="no-orders">
        No orders found for this product.
      </div>
    </div>
  </div>
</div>

<!-- Package Reviews Popup Modal -->
<div *ngIf="showPackageReviewsModal" class="modal-overlay" (click)="closePackageReviewsPopup()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Package Reviews for {{ selectedProduct?.name }}</h3>
      <button class="close-btn" (click)="closePackageReviewsPopup()">×</button>
    </div>
    <div class="orders-popup-content">
      <div *ngIf="selectedProduct?.packageReviews?.length > 0" class="orders-list">
        <a 
          *ngFor="let packageReviewId of selectedProduct.packageReviews" 
          [routerLink]="['/extensions/package-reviews', packageReviewId]"
          (click)="closePackageReviewsPopup()"
          class="order-link"
        >
          <vdr-chip class="order-chip">
            {{ packageReviewId }}
            <clr-icon shape="arrow right"></clr-icon>
          </vdr-chip>
        </a>
      </div>
      <div *ngIf="!selectedProduct?.packageReviews?.length" class="no-orders">
        No package reviews found for this product.
      </div>
    </div>
  </div>
</div>
